import { getModule } from "src/system/getModule.ts";
import { ResourceEnum } from "src/constants/constants.ts";

export const getB2bgateModules = () => [getModule(ResourceEnum.B2bGateOrder)];

export const getB2bgateForSupplierModules = () => [
  getModule(ResourceEnum.Product),
  getModule(ResourceEnum.Order),
  getModule(ResourceEnum.Manufacturer),
  getModule(ResourceEnum.Document),
  getModule(ResourceEnum.Owner),
  getModule(ResourceEnum.OwnerProfile),
  getModule(ResourceEnum.Unit),
  getModule(ResourceEnum.ProcessingTime),
  getModule(ResourceEnum.Customer),
  getModule(ResourceEnum.CustomerGroup),
];

export const getErpModules = () => [
  getModule(ResourceEnum.Language),
  getModule(ResourceEnum.VoucherSerie),
  getModule(ResourceEnum.Attribute),
  getModule(ResourceEnum.Category),
  getModule(ResourceEnum.Condition),
  getModule(ResourceEnum.Currency),
  getModule(ResourceEnum.CustomerGroup),
  getModule(ResourceEnum.Customer),
  getModule(ResourceEnum.DeliveryMethod),
  getModule(ResourceEnum.Discount),
  getModule(ResourceEnum.Manufacturer),
  getModule(ResourceEnum.Owner),
  getModule(ResourceEnum.OwnerProfile),
  getModule(ResourceEnum.PaymentMethod),
  getModule(ResourceEnum.PriceList),
  getModule(ResourceEnum.ProductGroup),
  getModule(ResourceEnum.Role),
  getModule(ResourceEnum.DeliveryService),
  getModule(ResourceEnum.Supplier),
  getModule(ResourceEnum.SupplierOrder),
  getModule(ResourceEnum.Unit),
  getModule(ResourceEnum.User),
  getModule(ResourceEnum.Country),
  getModule(ResourceEnum.Product),
  getModule(ResourceEnum.Warehouse),
  getModule(ResourceEnum.Stock),
  getModule(ResourceEnum.StockMove),
  getModule(ResourceEnum.Order),
  getModule(ResourceEnum.ProcessingTime),
  getModule(ResourceEnum.Marketplace),
  getModule(ResourceEnum.Vat),
  getModule(ResourceEnum.AccountingAccount),
  getModule(ResourceEnum.AccountingPosting),
  getModule(ResourceEnum.ConfigNumber),
  getModule(ResourceEnum.Document),
  getModule(ResourceEnum.BankAccount),
  getModule(ResourceEnum.BankTransaction),
  getModule(ResourceEnum.DocumentTemplate),
  getModule(ResourceEnum.EmailTemplate),
  getModule(ResourceEnum.AccountingPostingPosition),
  getModule(ResourceEnum.AccountingPostingVacantPosition),
  getModule(ResourceEnum.MarketingCompany),
  getModule(ResourceEnum.IntegrationToken),
  getModule(ResourceEnum.AccountingTemplate),
  getModule(ResourceEnum.BankSepa),
];
